import axios from 'axios';
import {Message} from 'element-ui';
import {serviceCheck} from './service-check';
import {getToken} from '@/utils/auth';
import qs from 'qs';
import {baseUrl, baseUrlV3, baseProUrl, appApiUrl, QUERY_ORDER_URL, INFO_DOWNLOAD_CHECK_URL} from '@/api/api-list';
import {encryptJson} from "~/utils/encryptJson";
import {aesDeciphering} from "~/utils/aesDeciphering";
import md5 from 'js-md5'

const service = axios.create({
  // baseURL: baseUrl(),
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    ENCRYPT: true,
  },
  withCredentials: true,
  crossDomain: true // 设置跨域为true
});

// request interceptor
service.interceptors.request.use(
  config => {
    const {method, params, data, url, queryType} = config;
    let baseUrlType = config.hasOwnProperty('baseUrlType') ? config.baseUrlType : 0; // 基本请求地址，0为基础的 1为专业版的
    let key = 'e1f3bc03983759fb2992f44434b21e0f'
    if (getToken()) {
      config.headers['Authorization'] = `Bearer ${getToken()}`;
    }
    // 判断传输是get还是post
    if (!config.method || config.method.toLowerCase() === 'get') {
      config.method = 'get'
    }
    // 取传值
    let datas = (params || data)
    // 不是文件并且有传值，加密传输
    if (queryType !== 'file' && datas) {
      if (config.method === 'get') {
        config.params = {data: encryptJson(datas)}
        config.data = null
      } else {
        config.data = qs.stringify({data: encryptJson(datas)})
        config.params = null
      }
    } else {
      config.data = datas;
    }
    const {timestamp} = serviceCheck(method, params, url);
    config.headers['timestamp'] = timestamp;
    config.headers['sign'] = md5(`${timestamp}|${key}`);
    config.url = (baseUrlType === 1 ? baseProUrl : baseUrlType === 2 ? baseUrlV3 : baseUrlType === 3 ? appApiUrl : baseUrl) + config.url;
    if (method === 'post') {
      delete config['params'];
    }
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    let res = response.data;
    if (res) {
      if (res.code && res.code !== 401 && res.code !== 1000) {
        let arr = [QUERY_ORDER_URL,INFO_DOWNLOAD_CHECK_URL]
        if (arr.every(item => {
          return !response.config.url.includes(item)
        })) {
          Message.closeAll();
          Message({
            message: res.msg || '连接超时，请重试',
            type: 'error',
            duration: 5 * 1000
          });
        }
        return Promise.reject(res);
      } else {
        try {
          if (typeof res.data === 'string') {
            res.data = aesDeciphering(res.data)
          }
        } catch (e) {
        }
        // 数据解密
        if (res.data && Object.prototype.toString.call(res.data) === '[object Object]') {
          if (res.data.encryptPhone) {
            res.data.encryptPhone = aesDeciphering(res.data.encryptPhone) + ''
          }
          if (res.data.encryptRealName) {
            res.data.encryptRealName = aesDeciphering(res.data.encryptRealName)
          }
          if (res.data.encryptAddress) {
            res.data.encryptAddress = aesDeciphering(res.data.encryptAddress)
          }
          if (res.data.encryptMail) {
            res.data.encryptMail = aesDeciphering(res.data.encryptMail)
          }
          if (res.data.encryptEmail) {
            res.data.encryptEmail = aesDeciphering(res.data.encryptEmail)
          }
          if (res.data.encryptAccount) {
            res.data.encryptAccount = aesDeciphering(res.data.encryptAccount)
          }
        }
        return res;
      }
    } else {
      return res;
    }
  },
  error => {
    Message.closeAll();
    Message({
      message: '连接超时，请重试',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);
export default service;
